import { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout, switchVendorType } from "../redux/auth/authSlice";
import service from "../services/service";
import endpoints from "../services/endpoints";

import {
  DropdownIcon,
  Notification,
  Search,
  Logout,
  Lock,
  Vendor,
  BackArw,
  GreenTick,
} from "../assests/ExportImageIcon";

import ChangePasswordModal from "../componants/changePassword/ChangePasswordModal";

import "./header.css";

const DASHBOARD_ROUTES = {
  venue: "/venue-dashboard",
  hotel: "/hotel-dashboard",
  event: "/event-dashboard",
  holiday: "/holiday-dashboard",
};

const VENDOR_TYPE_LABELS = {
  venue: "Venue",
  hotel: "Hotel",
  event: "Event",
  holiday: "Holiday Package",
};

const getInitials = (name, email) => {
  if (name) {
    const parts = name.trim().split(" ");
    return parts.length >= 2
      ? (parts[0][0] + parts[1][0]).toUpperCase()
      : parts[0].slice(0, 2).toUpperCase();
  }
  return email ? email[0].toUpperCase() : "V";
};

const Header = ({ onToggle }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [dropdownView, setDropdownView] = useState("menu");
  const [showConfirm, setShowConfirm] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const dropdownRef = useRef(null);
  const wsRef = useRef(null);
  const notificationTimeoutRef = useRef(new Map());

  const [hasUnreadNotification, setHasUnreadNotification] = useState(false);
  const [liveNotifications, setLiveNotifications] = useState([]);

  const accessToken = useSelector((state) => state?.auth?.access_token);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state.auth.user);
  const refresh_token = useSelector((state) => state.auth.refresh_token);

  const registeredVendorTypes = Array.isArray(user?.registered_vendor_types)
    ? user.registered_vendor_types
    : [];
  useEffect(() => {
    console.log("===== VENDOR NOTIFICATION WS START =====");
    console.log("Access Token:", accessToken ? "AVAILABLE" : "MISSING");

    const wsBaseUrl = process.env.REACT_APP_WS_BASE_URL;

    console.log("WS Base URL:", wsBaseUrl || "MISSING");

    if (!accessToken) {
      console.error("Notification WebSocket: accessToken missing");
      return;
    }

    if (!wsBaseUrl) {
      console.error("Notification WebSocket: REACT_APP_WS_BASE_URL is missing");
      return;
    }

    const wsUrl = `${wsBaseUrl}/notifications/?token=${encodeURIComponent(
      accessToken,
    )}`;

    console.log("Connecting Vendor Notification WebSocket:", wsUrl);

    const ws = new WebSocket(wsUrl);

    wsRef.current = ws;

    ws.onopen = () => {
      console.log("✅ Vendor Notification WebSocket connected");
    };

    ws.onmessage = (event) => {
      console.log("📩 Vendor WebSocket message received:", event.data);

      try {
        const response =
          typeof event.data === "string" ? JSON.parse(event.data) : event.data;

        console.log("Parsed Vendor WebSocket response:", response);

        if (response?.type !== "notification") {
          return;
        }

        const notification = response?.notification;

        if (!notification) {
          return;
        }

        console.log("🔔 Vendor Live notification received:", notification);

        setHasUnreadNotification(true);

        const toastId = `${Date.now()}-${Math.random()}`;

        const liveToast = {
          ...notification,
          toastId,
        };

        setLiveNotifications((prev) => [...prev, liveToast]);

        const timeoutId = setTimeout(() => {
          setLiveNotifications((prev) =>
            prev.filter((item) => item.toastId !== toastId),
          );

          notificationTimeoutRef.current.delete(toastId);
        }, 50000);

        notificationTimeoutRef.current.set(toastId, timeoutId);
      } catch (error) {
        console.error("Vendor Notification WebSocket message error:", error);
      }
    };

    ws.onerror = (error) => {
      console.error("❌ Vendor Notification WebSocket error:", error);
    };

    ws.onclose = (event) => {
      console.log(
        "❌ Vendor Notification WebSocket disconnected",
        event.code,
        event.reason,
      );
    };

    return () => {
      console.log("Cleaning Vendor Notification WebSocket");

      ws.close();

      if (wsRef.current === ws) {
        wsRef.current = null;
      }

      notificationTimeoutRef.current.forEach((timeoutId) => {
        clearTimeout(timeoutId);
      });

      notificationTimeoutRef.current.clear();
    };
  }, [accessToken]);
  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
        setDropdownView("menu");
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, []);

  const handleSwitchVendorType = (vendorType) => {
    if (vendorType === user?.vendor_type) {
      setShowDropdown(false);
      setDropdownView("menu");
      return;
    }

    dispatch(switchVendorType(vendorType));
    setShowDropdown(false);
    setDropdownView("menu");
    navigate(DASHBOARD_ROUTES[vendorType] || "/venue-dashboard");
  };

  const handleLogoutClick = () => {
    setShowDropdown(false);
    setShowConfirm(true);
  };

  const handleLogout = async () => {
    setLoading(true);

    try {
      await service.post(endpoints.auth.logout, {
        refresh: refresh_token,
      });
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(logout());
      navigate("/", { replace: true });

      setLoading(false);
      setShowConfirm(false);
    }
  };

  const initials = getInitials(user?.full_name, user?.email);

  return (
    <>
      {showConfirm && (
        <div className="confirm-overlay">
          <div className="confirm-modal">
            <h3>Logout</h3>

            <p>Are you sure you want to logout?</p>

            <div className="confirm-actions">
              <button
                className="commonBtnTransparent"
                onClick={() => setShowConfirm(false)}
                disabled={loading}
              >
                Cancel
              </button>

              <button
                className="commonBtnRed"
                onClick={handleLogout}
                disabled={loading}
              >
                {loading ? "Logging out..." : "Logout"}
              </button>
            </div>
          </div>
        </div>
      )}
      {showChangePassword && (
        <ChangePasswordModal onClose={() => setShowChangePassword(false)} />
      )}
      {liveNotifications.map((notification) => (
        <div className="liveNotificationToast" key={notification.toastId}>
          <div className="liveNotificationIcon">
            <img src={Notification} alt="notification" />
          </div>

          <div className="liveNotificationContent">
            <div className="liveNotificationTitle">
              {notification?.title || "New Notification"}
            </div>

            <div className="liveNotificationMessage">
              {notification?.message || ""}
            </div>
          </div>

          <button
            className="liveNotificationClose"
            onClick={() => {
              const timeoutId = notificationTimeoutRef.current.get(
                notification.toastId,
              );

              if (timeoutId) {
                clearTimeout(timeoutId);
                notificationTimeoutRef.current.delete(notification.toastId);
              }

              setLiveNotifications((prev) =>
                prev.filter((item) => item.toastId !== notification.toastId),
              );
            }}
          >
            ×
          </button>
        </div>
      ))}
      <header className="top-header">
        <div className="header-left">
          <button className="hamburger-btn" onClick={onToggle}>
            ☰
          </button>

          <div className="searchPart">
            <img src={Search} alt="search" />
            <input
              type="search"
              placeholder="Search bookings, vendors, customers..."
            />
          </div>
        </div>

        <div className="header-right">
          <div
            className="notification"
            onClick={() => {
              setHasUnreadNotification(false);
              navigate("/notification");
            }}
          >
            <img src={Notification} alt="notification" />

            <span
              className="redBg"
              style={{
                display: hasUnreadNotification ? "block" : "none",
              }}
            ></span>
          </div>

          <div className="profile-dropdown-wrapper" ref={dropdownRef}>
            <div
              className="profile-trigger"
              onClick={() => {
                setShowDropdown((prev) => !prev);
                setDropdownView("menu");
              }}
            >
              <div className="profile-avatar">{initials}</div>

              <div className="profile-info">
                <span className="profile-name">
                  {user?.full_name || user?.email}
                </span>

                <span className="profile-email">{user?.vendor_type}</span>
              </div>

              <img src={DropdownIcon} alt="dropdown" />
            </div>

            {showDropdown && (
              <div className="profile-dropdown">
                {dropdownView === "switch" ? (
                  <>
                    <button
                      className="dropdown-item d-flex"
                      onClick={() => setDropdownView("menu")}
                    >
                      <img
                        src={BackArw}
                        alt=""
                        style={{
                          width: 16,
                          marginRight: 8,
                        }}
                      />
                      Switch Profile
                    </button>

                    <div className="dropdown-divider" />

                    {registeredVendorTypes.map((type) => (
                      <button
                        key={type}
                        className="dropdown-item d-flex justify-content-between"
                        onClick={() => handleSwitchVendorType(type)}
                      >
                        <span>{VENDOR_TYPE_LABELS[type] || type}</span>

                        {type === user?.vendor_type && (
                          <img src={GreenTick} alt="" style={{ width: 14 }} />
                        )}
                      </button>
                    ))}
                  </>
                ) : (
                  <>
                    <div className="dropdown-header">
                      <span className="dropdown-label">Signed in as</span>

                      <span className="dropdown-email">{user?.email}</span>
                    </div>

                    <div className="dropdown-divider" />

                    {registeredVendorTypes.length > 1 && (
                      <button
                        className="dropdown-item d-flex"
                        onClick={() => setDropdownView("switch")}
                      >
                        <img
                          src={Vendor}
                          alt=""
                          style={{
                            width: 16,
                            marginRight: 8,
                          }}
                        />
                        Switch Profile
                      </button>
                    )}

                    <button
                      className="dropdown-item d-flex"
                      onClick={() => {
                        setShowDropdown(false);
                        setShowChangePassword(true);
                      }}
                    >
                      <img
                        src={Lock}
                        alt=""
                        style={{
                          width: 16,
                          marginRight: 8,
                        }}
                      />
                      Change Password
                    </button>

                    <button
                      className="dropdown-item d-flex"
                      onClick={handleLogoutClick}
                    >
                      <img
                        src={Logout}
                        alt=""
                        style={{
                          width: 16,
                          marginRight: 8,
                        }}
                      />
                      Logout
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
